// Launch checklist data. Pricing follows the published service price list:
// the proposal totals everything the visitor does NOT yet have, clamped to a
// minimum engagement of $4,997 and a package maximum of $24,997.

export const MIN_PRICE = 4997;
export const MAX_PRICE = 24997;

export const CHECKLIST_CATEGORIES = [
  {
    key: "branding",
    label: "Branding & Identity",
    items: [
      { id: "businessName", price: 497, label: "Business name development", question: "Is your business name locked in?", help: "A distinctive name that's clear to use and register." },
      { id: "logo", price: 1497, label: "Custom logo design package", question: "Do you have a professional logo?", help: "Crisp files in every format you'll need — print, web, labels." },
      { id: "brandColors", price: 497, label: "Brand palette & guidelines", question: "Are your brand colors and guidelines defined?", help: "Palette, typography, and a simple visual style guide." },
      { id: "brandMessaging", price: 797, label: "Brand messaging & tagline", question: "Do you have your messaging and tagline?", help: "What your brand stands for, said in a line or two." },
    ],
  },
  {
    key: "legal",
    label: "Legal & Compliance",
    items: [
      { id: "llcFormation", price: 997, label: "Business entity formation support", question: "Is your business entity formed?", help: "An LLC or corporation, registered and active." },
      { id: "einRegistration", price: 297, label: "EIN registration support", question: "Do you have an EIN?", help: "Your federal tax ID for the business." },
      { id: "complianceFramework", price: 1997, label: "Complete compliance framework", question: "Do you have a research-use compliance framework?", help: "Disclaimers, documentation, and research-use-only protocols." },
      { id: "labelTemplates", price: 997, label: "Compliant label templates", question: "Do you have compliant label templates?", help: "Product labels built to research-use requirements." },
    ],
  },
  {
    key: "website",
    label: "Website & Digital Presence",
    items: [
      { id: "domainName", price: 97, label: "Domain name acquisition", question: "Do you own your domain name?", help: "Your .com or another address that fits the brand." },
      { id: "webHosting", price: 297, label: "1-year premium hosting", question: "Is your hosting sorted?", help: "Fast, reliable space for your store to live on." },
      { id: "websiteDesign", price: 3997, label: "Custom storefront design & build", question: "Do you have a professional online store?", help: "A working storefront that's ready to take orders." },
      { id: "sslCertificate", price: 97, label: "SSL certificate setup", question: "Is SSL security active?", help: "HTTPS encryption for visitor trust and checkout." },
      { id: "productPhotography", price: 997, label: "Product photography package", question: "Do you have professional product photos?", help: "Clean, consistent imagery for your catalog." },
      { id: "productCopywriting", price: 797, label: "Product descriptions & copywriting", question: "Are your product descriptions written?", help: "Clear, compliant copy for every product page." },
    ],
  },
  {
    key: "product",
    label: "Product & Inventory",
    items: [
      { id: "supplierAccess", price: 1997, label: "Verified supplier network access", question: "Do you have a verified peptide supplier?", help: "A dependable source for quality research peptides." },
      { id: "productCatalog", price: 497, label: "Product catalog setup", question: "Is your product catalog defined?", help: "The list of products you plan to offer at launch." },
      { id: "coaDocumentation", price: 497, label: "COA documentation package", question: "Do you have COAs for your products?", help: "Third-party testing documentation per product." },
      { id: "inventorySystem", price: 797, label: "Inventory management setup", question: "Is inventory management in place?", help: "A system that tracks stock levels and orders." },
    ],
  },
  {
    key: "payment",
    label: "Payment & Fulfillment",
    items: [
      { id: "paymentProcessor", price: 797, label: "Payment processing setup", question: "Can you accept card payments?", help: "A processor that works with peptide businesses." },
      { id: "merchantAccount", price: 497, label: "Merchant account assistance", question: "Do you have a merchant account?", help: "The account behind your payment processing." },
      { id: "fulfillmentSetup", price: 1497, label: "Fulfillment & dropship integration", question: "Is fulfillment worked out?", help: "How orders get stored, packed, and shipped." },
      { id: "shippingSolution", price: 497, label: "Shipping configuration", question: "Is your shipping stack configured?", help: "Carriers, labels, and tracking for every order." },
    ],
  },
  {
    key: "marketing",
    label: "Marketing & Growth",
    items: [
      { id: "socialMediaSetup", price: 497, label: "Social media setup", question: "Are your social accounts set up?", help: "The profiles where your audience already spends time." },
      { id: "emailMarketing", price: 797, label: "Email marketing setup", question: "Is email marketing ready?", help: "A platform for newsletters and automations." },
      { id: "marketingMaterials", price: 997, label: "Marketing materials package", question: "Do you have launch marketing materials?", help: "Ads, banners, and promotional content in your brand." },
      { id: "seoFoundation", price: 797, label: "SEO foundation", question: "Do you have an SEO foundation?", help: "Keyword research and an on-page optimization plan." },
    ],
  },
];

export const ALL_ITEMS = CHECKLIST_CATEGORIES.flatMap((c) =>
  c.items.map((i) => ({ ...i, category: c.key }))
);
